import React from "react";
import GestionAlojamientoLogiflex from "./GestionAlojamientoLogiflex";
import { GESTION_ALOJAMIENTO_MODOS } from "./gestionAlojamientoConfig";

const GestionCheckOut = () => (
  <GestionAlojamientoLogiflex config={GESTION_ALOJAMIENTO_MODOS.checkout} />
);

export default GestionCheckOut;
